module.exports = __webpack_public_path__ + "static/comment-3f0f76edb447002b60a29d4f2fafd858.png";